import CHECKOUT_ERRORS, { DCF_ACTION_CODE } from '../constants/checkout-error-enums';

const getCheckoutError = error => {
  let info = {};
  let reason = CHECKOUT_ERRORS.INVALID_PARAMETER;
  if (error === CHECKOUT_ERRORS.ENCRYPTED_CARD) {
    info = {
      location: CHECKOUT_ERRORS.ENCRYPTED_CARD,
      message: 'encryptedCard is required but is missing'
    };
  } else if (error === CHECKOUT_ERRORS.SRC_DIGITAL_CARD_ID) {
    info = {
      location: CHECKOUT_ERRORS.SRC_DIGITAL_CARD_ID,
      message: 'The card ID was required but is missing'
    };
    reason = CHECKOUT_ERRORS.CARDID_MISSING;
  } else if (error === CHECKOUT_ERRORS.DPA_TRANSACTION_OPTIONS) {
    info = {
      location: CHECKOUT_ERRORS.DPA_TRANSACTION_OPTIONS,
      message: 'dpaTransactionOptions must be an object'
    };
    reason = CHECKOUT_ERRORS.INVALID_PARAMETER;
  } else {
    info = {
      location: `${CHECKOUT_ERRORS.ENCRYPTED_CARD}, ${CHECKOUT_ERRORS.SRC_DIGITAL_CARD_ID}`,
      message: 'either encryptedCard or srcDigitalCardId is required but is missing'
    };
  }
  return {
    dcfActionCode: DCF_ACTION_CODE,
    details: [info],
    message: '1 error found in checkout(), please check error for details',
    reason
  };
};

export default getCheckoutError;
